import React, { useState, useRef, useMemo } from 'react';
import '../../Css/Botones/botones.css';
import '../../Css/catalogobase/catalogobase.css';

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';

import Navbar from '../../components/navbar/navbar';
import Sidebar from '../../components/sidebar/sidebar';

import { obtenerEntidades } from '../../Services/serviciohttp';
import { API_URLS } from '../../Services/servicioURL';

interface RustType {
    id: string;
    cve: string;
    nombre: string;
}

const Rust: React.FC = () => {

    const [mode, setMode] = useState<'view' | 'new' | 'edit'>('view');
    const [formData, setFormData] = useState({ id: '', cve: '', nombre: '' });
    const [mostrarTabla, setMostrarTabla] = useState(false);
    const [data, setData] = useState<RustType[]>([]);
    const [searchTerm, setSearchTerm] = useState('');

    const toast = useRef<Toast>(null);

    const filteredData = useMemo(() => {
        if (!searchTerm) return data;
        const searchLower = searchTerm.toLowerCase();
        return data.filter(item =>
            Object.values(item).some(val =>
                val?.toString().toLowerCase().includes(searchLower)
            )
        );
    }, [data, searchTerm]);

    const showMessage = (severity: any, summary: string, detail: string) => {
        toast.current?.show({ severity, summary, detail, life: 3000 });
    };

    const limpiarFormulario = () => {
        setFormData({ id: '', cve: '', nombre: '' });
        setMode('view');
    };

    const obtenerRust = async () => {
        try {
            const result = await obtenerEntidades(API_URLS.rust.obtener);
            setData(result);
        } catch {
            showMessage('error', 'Error', 'Error al cargar los datos');
        }
    };

    const handleGuardar = async () => {
        const { id, cve, nombre } = formData;

        if (!cve || !nombre) {
            showMessage('warn', 'Campos requeridos', 'Debe completar todos los campos');
            return;
        }

        try {
            if (mode === 'new') {
                await fetch(API_URLS.rust.registrar, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ cve, nombre })
                });
                showMessage('success', '¡Registro creado!', 'Categoría creada correctamente');
            } else if (mode === 'edit') {

                if (!window.confirm('¿Actualizar registro?')) return;

                await fetch(API_URLS.rust.actualizar(id), {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ cve, nombre })
                });

                showMessage('success', '¡Actualizado!', 'Registro actualizado correctamente');
            }

            limpiarFormulario();
            obtenerRust();

        } catch {
            showMessage('error', 'Error', 'No se pudo guardar el registro');
        }
    };

    const handleEliminar = async () => {
        if (!formData.id) {
            showMessage('warn', 'Advertencia', 'Seleccione un registro');
            return;
        }

        if (!window.confirm('¿Eliminar registro?\n\nEsta acción no se puede deshacer.')) return;

        try {
            await fetch(API_URLS.rust.eliminar(formData.id), { method: 'DELETE' });
            showMessage('success', 'Eliminado', 'Registro eliminado correctamente');
            limpiarFormulario();
            obtenerRust();
        } catch {
            showMessage('error', 'Error', 'No se pudo eliminar');
        }
    };

    const handleSeleccionar = (item: RustType) => {
        setFormData(item);
        setMostrarTabla(false);
        setSearchTerm('');
        setMode('view');
    };

    const getModeIndicator = () => {
        switch (mode) {
            case 'new': return { text: 'NUEVO REGISTRO', color: '#10b981', icon: 'pi-plus' };
            case 'edit': return { text: 'EDITANDO', color: '#f59e0b', icon: 'pi-pencil' };
            default: return { text: 'MODO CONSULTA', color: '#374151', icon: 'pi-eye' };
        }
    };

    const modeInfo = getModeIndicator();

    return (
        <>
            <Navbar />
            <Sidebar />
            <Toast ref={toast} />

            {/* MODAL CONSULTA */}
            {mostrarTabla && (
                <div
                    onClick={() => setMostrarTabla(false)}
                    style={{
                        position: 'fixed',
                        inset: 0,
                        backgroundColor: 'rgba(0,0,0,.6)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 2000
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '16px',
                            padding: '24px',
                            width: '95%',
                            maxWidth: '720px',
                            maxHeight: '85vh',
                            boxShadow: '0 25px 50px rgba(0,0,0,.25)',
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        <h3 style={{ marginBottom: '15px' }}>📂 Consultar Categorías</h3>

                        <InputText
                            placeholder="Buscar..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ width: '100%', marginBottom: '15px' }}
                        />

                        <div style={{
                            border: '1px solid #e5e7eb',
                            borderRadius: '10px',
                            overflow: 'hidden',
                            flex: 1
                        }}>
                            <div style={{
                                maxHeight: '320px',
                                overflowY: 'auto'
                            }}>
                                <table style={{
                                    width: '100%',
                                    borderCollapse: 'collapse',
                                    tableLayout: 'fixed'
                                }}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#f8fafc' }}>
                                            <th style={{ padding: '12px', width: '80px', textAlign: 'left' }}>ID</th>
                                            <th style={{ padding: '12px', width: '120px', textAlign: 'left' }}>Clave</th>
                                            <th style={{ padding: '12px', textAlign: 'left' }}>Nombre</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData.length > 0 ? (
                                            filteredData.map(item => (
                                                <tr
                                                    key={item.id}
                                                    onClick={() => handleSeleccionar(item)}
                                                    style={{
                                                        cursor: 'pointer',
                                                        borderTop: '1px solid #f1f5f9'
                                                    }}
                                                    onMouseEnter={(e) => e.currentTarget.style.background = '#eef6ff'}
                                                    onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
                                                >
                                                    <td style={{ padding: '12px' }}>{item.id}</td>
                                                    <td style={{ padding: '12px' }}>{item.cve}</td>
                                                    <td style={{
                                                        padding: '12px',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis'
                                                    }}>
                                                        {item.nombre}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={3} style={{
                                                    padding: '20px',
                                                    textAlign: 'center',
                                                    color: '#6b7280'
                                                }}>
                                                    No hay resultados
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* CONTENIDO */}
            <div className="content-wrapper" style={{ padding: '20px' }}>
                <div style={{
                    backgroundColor: 'white',
                    borderRadius: '16px',
                    padding: '24px',
                    maxWidth: '800px',
                    margin: '0 auto'
                }}>
                    <h2>📂 Gestión de Categorías</h2>

                    <div style={{
                        padding: '8px 16px',
                        backgroundColor: modeInfo.color,
                        color: 'white',
                        borderRadius: '20px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '8px',
                        marginBottom: '20px'
                    }}>
                        <i className={`pi ${modeInfo.icon}`}></i>
                        {modeInfo.text}
                    </div>

                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 2fr',
                        gap: '20px'
                    }}>
                        <InputText value={formData.id} disabled placeholder="ID" />

                        <InputText
                            value={formData.cve}
                            disabled={mode === 'view'}
                            placeholder="Clave"
                            onChange={(e) => setFormData(prev => ({ ...prev, cve: e.target.value }))}
                        />

                        <InputText
                            value={formData.nombre}
                            disabled={mode === 'view'}
                            placeholder="Nombre"
                            onChange={(e) => setFormData(prev => ({ ...prev, nombre: e.target.value }))}
                        />
                    </div>

                    <div style={{
                        marginTop: '20px',
                        display: 'flex',
                        gap: '10px',
                        justifyContent: 'center'
                    }}>
                        {mode === 'view' ? (
                            <>
                                <Button label="Consultar" icon="pi pi-search" onClick={() => { setMostrarTabla(true); obtenerRust(); }} />
                                <Button label="Nuevo" icon="pi pi-plus" severity="success" onClick={() => { limpiarFormulario(); setMode('new'); }} />
                                <Button label="Editar" icon="pi pi-pencil" severity="warning" disabled={!formData.id} onClick={() => setMode('edit')} />
                                <Button label="Eliminar" icon="pi pi-trash" severity="danger" disabled={!formData.id} onClick={handleEliminar} />
                            </>
                        ) : (
                            <>
                                <Button label="Guardar" icon="pi pi-check" severity="success" onClick={handleGuardar} />
                                <Button label="Cancelar" icon="pi pi-times" severity="secondary" onClick={limpiarFormulario} />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Rust;